<template>
  <div class="home">
    <Banner :list="banners" :myHeight="220" :hadFrom="true"></Banner>
    <div class="home-news-box">
      <div class="home-news container">
        <div class="home-news-logo">
          <img src="@/assets/image/45.png" alt="news" />
        </div>
        <div class="swiper-container news-container">
          <div class="swiper-wrapper">
            <template v-for="(item, index) in infoList">
              <div
                class="swiper-slide home-news-item"
                :key="index"
                @click="toArticle(item)"
              >
                <a target="_blank">{{ item.title }}</a>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="home-data">
        <template v-for="(item, index) in list">
          <div class="home-data-item" :key="index">
            <div class="img-box">
              <img :src="item.icon" class="animated bounceIn" alt="datas" />
            </div>
            <p class="name mt-2">{{ item.title }}</p>
          </div>
        </template>
      </div>
      <div class="home-business">
        <div class="main-title">
          <h1 class="name">一站式智能代办平台 让建筑资质办理更高效</h1>
        </div>
        <div class="home-business-main">
          <div class="business-img wow bounceIn">
            <div class="swiper-container business-container">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="(item, index) in businessList"
                  :key="index"
                  :style="{
                    backgroundImage: 'url(' + item.img + ')',
                    backgroundSize: 'cover',
                  }"
                >
                  <!-- <img :src="item.img" alt="" /> -->
                </div>
              </div>
            </div>
          </div>
          <div class="business-menu">
            <template v-for="(item, index) in business">
              <div
                class="list"
                :key="index"
                @mouseenter="hoverBusiness(index)"
                @mouseleave="swiperHover = false"
                @click="toPage(item.router)"
              >
                <h3 class="title m-0">{{ item.name }}</h3>
                <ul class="item">
                  <li
                    v-for="(child, idx) in item.child"
                    :key="idx"
                    :class="{
                      active:
                        businessActive == index && businessBannerActive == idx,
                    }"
                    @mouseenter="changeSwiper(idx)"
                    @mouseleave="startAutoPlay"
                  >
                    {{ child.name }}
                  </li>
                </ul>
                <div
                  class="arrow animated"
                  :class="{
                    fadeInRight: swiperHover,
                    fadeOutRight: !swiperHover,
                  }"
                  v-show="businessActive == index"
                >
                  <img src="../assets/image/left-arrow.png" alt="" />
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="m-home-business-main">
          <template v-for="(item, index) in business">
            <div
              class="list"
              :key="index"
              @mouseenter="hoverBusiness(index)"
              @mouseleave="swiperHover = false"
              @click="toPage(item.router)"
            >
              <div class="img-box">
                <img :src="item.img" alt="" />
              </div>
              <h3 class="title m-0">{{ item.name }}</h3>
            </div>
          </template>
        </div>
      </div>
      <div class="home-step">
        <div class="main-title">
          <h1 class="name">一步到位 助您实现建筑资质快速办理</h1>
        </div>
        <div class="home-step-main">
          <div class="step-menu">
            <template v-for="(item, index) in step">
              <div
                class="item"
                :class="{ active: stepActive >= index }"
                @mouseenter="slectStep(index)"
                @mouseleave="stepHover = false"
                :key="index"
              >
                {{ item.name }}
              </div>
            </template>
          </div>
          <div class="m-step-menu">
            <template v-for="(item, index) in step">
              <div
                class="item"
                :class="{ active: stepActive == index }"
                @mouseenter="slectStep(index)"
                @mouseleave="stepHover = false"
                :key="index"
              >
                {{ item.name }}
              </div>
            </template>
          </div>
          <div class="step-content">
            <div class="m-step-img animated" :class="{ fadeIn: stepHover }">
              <img :src="step[stepActive].img" />
            </div>
            <div class="step">
              <div class="title">
                <h3 class="name">{{ step[stepActive].name }}</h3>
                <p class="sname">{{ step[stepActive].sname }}</p>
              </div>
              <p class="desc pr-6">{{ step[stepActive].desc }}</p>
              <div class="btns">
                <a-button
                  class="getPrice wow pulse"
                  data-wow-delay="300ms"
                  data-wow-iteration="infinite"
                  data-wow-duration="3s"
                  type="primary"
                  @click="
                    $toConnectLink($store.state.companyInfo.external_service)
                  "
                >
                  获取报价
                </a-button>
                <a-button
                  class="getDetail wow pulse"
                  data-wow-delay="300ms"
                  data-wow-iteration="infinite"
                  data-wow-duration="3s"
                  @click="$toConnectLink"
                >
                  了解详情>>
                </a-button>
              </div>
            </div>
            <div class="step-img animated" :class="{ fadeIn: stepHover }">
              <img :src="step[stepActive].img" />
            </div>
          </div>
        </div>
      </div>
      <div class="home-scenes">
        <div class="main-title">
          <h1 class="name">建筑资质服务全场景覆盖</h1>
          <h3 class="same">致力于让客户在一个平台解决所有资质业务需求</h3>
        </div>
        <div class="home-scenes-main">
          <div class="scenes-menu">
            <div class="list">
              <template v-for="(item, index) in categoryList">
                <div
                  class="item"
                  :class="{ active: sencesActive == index }"
                  @mouseenter="slectScenes(index, item.id)"
                  :key="index"
                >
                  {{ item.name }}
                </div>
              </template>
            </div>
            <div class="more" @click="$toConnectLink">立即订制 >></div>
          </div>
          <div class="scenes-content">
            <div class="scenes-img">
              <img src="@/assets/image/servebg.jpg" />
            </div>
            <div class="list">
              <template v-if="intelligentList.length !== 0">
                <template v-for="(item, index) in intelligentList">
                  <div class="item" :key="index">
                    <div class="top">
                      <h3 class="title m-0">{{ item.name }}</h3>
                      <a-button class="more" @click="$toConnectLink">
                        立即咨询
                      </a-button>
                    </div>
                    <ul class="content mt-3">
                      <li>发布者：{{ item.publisher }}</li>
                      <li>{{ item.publish_time_name }}发布</li>
                      <li>所在地区：{{ item.district }}</li>
                      <li>
                        状态：<span>{{ item.trade_state_name }}</span>
                      </li>
                    </ul>
                  </div>
                </template>
              </template>
              <template v-else>
                <div class="noDate">
                  <img src="@/assets/image/noDate.png" alt="" />
                  <p>没有数据</p>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="home-product">
        <div class="main-title">
          <h1 class="name">助力10万+建企实现产业规模升级</h1>
        </div>
        <div class="home-product-main">
          <productBanner></productBanner>
        </div>
      </div>
      <div class="home-case">
        <template v-for="(item, index) in allCase">
          <div class="item" @click="toCase" :key="index">
            <img :src="item" alt="" />
          </div>
        </template>
      </div>
      <div class="home-policy">
        <div class="home-policy-main">
          <a-tabs default-active-key="1" @change="changePolicy">
            <a-tab-pane key="1" tab="国家政策">
              <div class="list">
                <template v-for="(item, index) in policyList">
                  <div
                    class="item"
                    :key="index"
                    @click="toArticle(item)"
                    @mouseenter="enter(index, 'policy')"
                    @mouseleave="leave()"
                  >
                    <span class="time">
                      {{ item.create_time | getTime }}
                      <!-- {{item.create_time.split(' ')[0].split('-')[1]}} - {{item.create_time.split(' ')[0].split('-')[2]}} -->
                    </span>
                    <span
                      class="title"
                      :class="mouseenterIndex == index ? 'spanColor' : ''"
                      >{{ item.guide }}</span
                    >
                  </div>
                </template>
              </div>
            </a-tab-pane>
            <a-tab-pane key="2" tab="行业动态">
              <div class="list">
                <template v-for="(item, index) in industryList">
                  <div
                    class="item"
                    :key="index"
                    @click="toArticle(item)"
                    @mouseenter="enter(index, 'industry')"
                    @mouseleave="leave()"
                  >
                    <span class="time">{{ item.create_time | getTime }}</span>
                    <span
                      class="title"
                      :class="mouseenterIndex == index ? 'spanColor' : ''"
                      >{{ item.guide }}</span
                    >
                  </div>
                </template>
              </div>
            </a-tab-pane>
          </a-tabs>
        </div>
        <div class="home-policy-bg">
          <img :src="cover_url" alt="" />
        </div>
      </div>
    </div>
    <div class="home-ensure">
      <div class="list py-6">
        <template v-for="(item, index) in ensure">
          <div class="item" :key="index">
            <img :src="item.img" alt="ensure" class="animated bounceIn" />
            <div class="desc ml-2">
              <div class="title mb-1">{{ item.title }}</div>
              <p v-html="item.desc"></p>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate } from "../assets/js/formDate.js";
import Swiper from "swiper";
import Banner from "@/components/common/banner";
import productBanner from "@/components/home/product";
import { WOW } from "wowjs";

export default {
  name: "Home",
  components: {
    Banner,
    productBanner,
  },
  filters: {
    getTime(val) {
      let c = new Date(val.replace(/-/g, "/"));
      return formatDate(c, "MM-dd");
    },
  },
  data() {
    return {
      //行业Id
      industry: 0,
      intelligentList: [],
      mouseenterIndex: null,
      cover_url: "",
      stepHover: false,
      swiperHover: false,
      businessSwiper: null,
      businessList: [],
      businessActive: 0,
      businessBannerActive: 0,
      stepActive: 0,
      sencesActive: 0,
      banners: {
        list: [],
      },
      list: [
        {
          icon: require("@/assets/image/66.png"),
          title: "专注建企服务",
        },
        {
          icon: require("@/assets/image/67.png"),
          title: "服务全国城市",
        },
        {
          icon: require("@/assets/image/68.png"),
          title: "企业共同选择",
        },
        {
          icon: require("@/assets/image/69.png"),
          title: "全国用户使用",
        },
      ],

      business: [
        {
          name: "施工总承包资质",
          router: "/contract",
          img: require("@/assets/image/business1.jpg"),
          child: [
            {
              name: "建筑工程施工总承包",
              img: require("@/assets/image/business1.jpg"),
            },
            {
              name: "公路工程施工总承包",
              img: require("@/assets/image/business1.jpg"),
            },
            {
              name: "市政公用工程施工总承包",
              img: require("@/assets/image/business1.jpg"),
            },
            {
              name: "电力工程施工总承包",
              img: require("@/assets/image/business1.jpg"),
            },
          ],
        },
        {
          name: "施工专业承包资质",
          router: "/qualification",
          img: require("@/assets/image/business2.jpg"),
          child: [
            {
              name: "防水防腐保温工程",
              img: require("@/assets/image/business2.jpg"),
            },
            {
              name: "建筑装修装饰工程",
              img: require("@/assets/image/business2.jpg"),
            },
            {
              name: "地基基础工程",
              img: require("@/assets/image/business2.jpg"),
            },
            {
              name: "建筑机电安装工程",
              img: require("@/assets/image/business2.jpg"),
            },
          ],
        },
        {
          name: "工程设计资质",
          router: "/design",
          img: require("@/assets/image/business3.jpg"),
          child: [
            {
              name: "建筑装饰工程设计专项",
              img: require("@/assets/image/business3.jpg"),
            },
            {
              name: "环境工程设计专项",
              img: require("@/assets/image/business3.jpg"),
            },
            {
              name: "市政行业工程专项",
              img: require("@/assets/image/business3.jpg"),
            },
            {
              name: "建筑工程设计",
              img: require("@/assets/image/business3.jpg"),
            },
          ],
        },
        {
          name: "其他建筑资质",
          router: "/decoration",
          img: require("@/assets/image/business4.jpg"),
          child: [
            {
              name: "施工劳务企业资质",
              img: require("@/assets/image/business4.jpg"),
            },
            {
              name: "承装（修、试）电力设施许可证",
              img: require("@/assets/image/business4.jpg"),
            },
          ],
        },
      ],
      ensure: [
        {
          img: require("@/assets/image/46.png"),
          title: "低价透明",
          desc: "业内统一报价<br>无任何隐形消费",
        },
        {
          img: require("@/assets/image/47.png"),
          title: "一站式服务",
          desc: "一对一专属顾问<br>7*24小时一站式服务",
        },
        {
          img: require("@/assets/image/48.png"),
          title: "信息保密",
          desc: "客户信息保密<br>安全保障 绝不泄露",
        },
        {
          img: require("@/assets/image/49.png"),
          title: "售后无忧",
          desc: "服务过程全面跟进<br>资深顾问专业解答",
        },
      ],
      step: [
        {
          step: "提出资质需求",
          name: "提出资质需求",
          sname: "FIRST STEP",
          desc:
            "根据企业的实际发展需求和需要承接的项目给出最全面最优的建议方案，再根据实际面谈协商，签订资质合同。",
          img: require("@/assets/image/step1.png"),
        },
        {
          step: "配备资质人员",
          name: "配备资质人员",
          sname: "SECOND STEP",
          desc:
            "根据企业办理所需的资质、细分所属领域进行资质人员的补充和沟通，匹配资质所需要的人才及为企业发展提供人才供给。",
          img: require("@/assets/image/step2.png"),
        },
        {
          step: "申报资料",
          name: "申报资料",
          sname: "THIRD STEP",
          desc:
            "根据已有的申报资料，对其整理后和相关部门负责人进行详细沟通，通过网络申报电子版资料，为企业作出最完善的资料提交。",
          img: require("@/assets/image/step3.png"),
        },
        {
          step: "取得企业资质",
          name: "取得企业资质",
          sname: "FOURTH STEP",
          desc:
            "经过上述三个步骤后，最终等待住建委初审意见公示，然后到最终住建委核准意见公示，最快的速度获取资质证书，承接项目。",
          img: require("@/assets/image/step4.png"),
        },
      ],
      allCase: [
        require("@/assets/image/case/1.png"),
        require("@/assets/image/case/2.png"),
        require("@/assets/image/case/4.png"),
        require("@/assets/image/case/5.png"),
        require("@/assets/image/case/6.png"),
        require("@/assets/image/case/7.png"),
        require("@/assets/image/case/8.png"),
        require("@/assets/image/case/9.png"),
        require("@/assets/image/case/10.png"),
        require("@/assets/image/case/11.png"),
        require("@/assets/image/case/14.png"),
        require("@/assets/image/case/15.png"),
        require("@/assets/image/case/16.png"),
        require("@/assets/image/case/20.png"),
        require("@/assets/image/case/21.png"),
      ],
      policyList: [],
      infoList: [],
      industryList: [],
      categoryList: [],
    };
  },

  methods: {
    toPage(val) {
      this.$router.push(val);
    },
    getBannerList() {
      let data = {
        launchPage: 10,
        launchFacility: 10,
      };
      if (this.$mobile) {
        data.launchFacility = 20;
      }
      this.$api.getBannerList(data).then((res) => {
        this.banners.list = res.data.list;
      });
    },
    getIntelligentList() {
      this.$api
        .getIntelligentList({
          industry: this.industry,
          limit: 4,
        })
        .then((res) => {
          this.intelligentList = res.data.list;
        });
    },
    // 鼠标移入政策 行业
    enter(index, name) {
      this.mouseenterIndex = index;
      if (name == "policy") {
        this.cover_url = this.policyList[index].cover_url;
      } else if (name == "industry") {
        this.cover_url = this.industryList[index].cover_url;
      }
    },
    leave() {
      this.mouseenterIndex = null;
    },
    toArticle(item) {
      this.$router.push({
        name: "article",
        query: {
          id: item.id,
          flag: item.flag || 0,
          except: item.except || 0,
          categoryId: item.category_id || 0,
          professionId: item.profession || 0,
        },
      });
    },
    changeSwiper(index) {
      this.businessBannerActive = index;
      this.businessSwiper.stopAutoplay();
      this.businessSwiper.slideTo(index + 1, 1000, false);
    },
    startAutoPlay() {
      this.businessSwiper.startAutoplay();
    },
    hoverBusiness(index) {
      this.swiperHover = true;
      if (this.businessActive == index) return;
      this.businessActive = index;
      this.businessList = this.business[this.businessActive].child;
      this.businessSwiper.destroy(false);
      this.initBusinessSwiper();
    },
    toCase() {
      this.$router.push("case");
    },
    changePolicy(e) {
      if (e == 1) {
        this.cover_url = this.policyList[0].cover_url;
      } else if (e == 2) {
        this.cover_url = this.industryList[0].cover_url;
      }
    },
    slectStep(index) {
      if (this.stepActive == index) return;
      this.stepHover = true;
      this.stepActive = index;
    },
    slectScenes(index, id) {
      this.sencesActive = index;
      this.industry = id;
      this.getIntelligentList();
      // 接分类接口
    },
    initNewsSwiper() {
      var newsSwiper = new Swiper(".news-container", {
        loop: true,
        speed: 1000,
        autoplay: 3000,
        // direction: 'vertical',
        slidesPerView: 3,
        slidesPerGroup: 3,
      });
    },
    initBusinessSwiper() {
      let _this = this;
      this.businessSwiper = new Swiper(".business-container", {
        loop: true,
        autoplay: 2000,
        speed: 1000,
        effect: "fade",
        fade: {
          crossFade: true,
        },
        observer: true,
        observerParents: true,
        onSlideChangeStart: function (swiper) {
          _this.businessBannerActive = swiper.realIndex;
        },
      });
    },
    getPolicy() {
      this.$api
        .getArticleList({
          flag: "policy",
          limit: 6,
        })
        .then((res) => {
          this.policyList = res.data.list;
          this.cover_url = this.policyList[0].cover_url;
          // this.newArtcle = res.data.list;
        });
    },
    getInfo() {
      this.$api
        .getArticleList({
          flag: "info",
          limit: 6,
        })
        .then((res) => {
          this.infoList = res.data.list;
          this.$nextTick(() => {
            this.initNewsSwiper();
          });
        });
    },
    getIndustry() {
      this.$api
        .getArticleList({
          flag: "industry",
          limit: 6,
        })
        .then((res) => {
          this.industryList = res.data.list;
        });
    },
    getCategoryList() {
      this.$api.getArticleProfession().then((res) => {
        this.categoryList = res.data;
        this.industry = this.categoryList[0].id;
        this.getIntelligentList();
      });
    },
  },
  created() {
    this.businessList = this.business[this.businessActive].child;
    this.getPolicy();
    this.getInfo();
    this.getIndustry();
    this.getCategoryList();
    this.getBannerList();
  },

  mounted() {
    var wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true,
      live: true,
    });
    wow.init();
    this.initBusinessSwiper();
  },
};
</script>
<style lang="scss">
@import "@/assets/css/home.scss";
</style>
